import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, FileText } from "lucide-react";

export const openCert = async (lid) => {
  try {
    const r = await api.get(`/leave/${lid}/certificate`, { responseType: "blob" });
    window.open(URL.createObjectURL(r.data), "_blank");
  } catch (e) { toast.error(apiError(e)); }
};

export const uploadCert = (lid, file) => {
  const fd = new FormData(); fd.append("file", file);
  return api.post(`/leave/${lid}/certificate`, fd, { headers: { "Content-Type": "multipart/form-data" } });
};

export function CertButtons({ r, canUpload, onDone }) {
  const [busy, setBusy] = useState(false);
  if (r.kind !== "sickness") return null;
  const onFile = async (e) => {
    const f = e.target.files[0]; if (!f) return;
    setBusy(true);
    try { await uploadCert(r.id, f); toast.success("Sick certificate uploaded"); onDone && onDone(); }
    catch (err) { toast.error(apiError(err)); } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <>
      {r.certificate && <button onClick={() => openCert(r.id)} data-testid={`leave-view-cert-${r.id}`} className="inline-flex items-center gap-1 text-sm font-medium text-slateblue hover:underline"><FileText size={14} /> Sick certificate</button>}
      {!r.certificate && !canUpload && <span className="text-xs text-ink-muted" data-testid={`leave-no-cert-${r.id}`}>No sick certificate yet</span>}
      {canUpload && (
        <label className="inline-flex cursor-pointer items-center gap-1 rounded-lg border border-border px-3 py-1.5 text-sm font-medium text-ink hover:bg-secondary">
          <input type="file" accept="image/*,application/pdf" className="hidden" onChange={onFile} data-testid={`leave-upload-cert-${r.id}`} />
          <Upload size={14} /> {busy ? "Uploading…" : r.certificate ? "Replace certificate" : "Upload sick certificate"}
        </label>
      )}
    </>
  );
}
